import { createAsyncComponent, withInstall } from '@mts-fe/utils';
import _ApprovalFlowBtn from './src/ApprovalFlowBtn.vue';

export * from './src/types';
export const ApprovalFlowBtn = withInstall(_ApprovalFlowBtn);
export const ApprovalFlowModal = createAsyncComponent(() => import('./src/ApprovalFlowModal.vue'));
export const ApprovalRecordModal = createAsyncComponent(
  () => import('./src/ApprovalRecordModal.vue'),
);
